import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-modal';
import './AdminEmails.scss';
import { ConfirmContext } from '../../components/ConfirmModal';
import axios from 'axios';
import { API_URL } from '../../../config/constants';

const customStyles = {
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.24)',
        zIndex: 98
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        padding: 'none',
        borderRadius: '15px',
        boxShadow: '7px 7px 5px rgba(0, 0, 0, 0.35)'
    },
};

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');
function AdminEmails({
    isOpen,
    onRequestClose,
    contentLabel,
}) {

    let subtitle;
    const { confirm } = useContext(ConfirmContext);
    const [emailList, setEmailList] = useState([]);
    const [newEmail, setNewEmail] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [editingEmail, setEditingEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const getAdminEmails = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${API_URL}/monitoring-manage/getAdminEmails`);
            if (res.data.success) {
                setEmailList(res.data.emails || []);
            }
        } catch (err) {
            console.error(err);
            alert('이메일 목록 조회에 실패했습니다.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            getAdminEmails();
            setNewEmail('');
            setEditingId(null);
            setEditingEmail('');
        }
    }, [isOpen]);

    const handleAdd = async () => {
        try {
            if (!newEmail.trim()) {
                alert('이메일을 입력해주세요.');
                return;
            }

            await axios.post(`${API_URL}/monitoring-manage/createAdminEmail`, {
                email: newEmail.trim(),
            });

            setNewEmail('');
            getAdminEmails();
        } catch (err) {
            console.error(err);
            alert(err?.response?.data?.message || '이메일 추가에 실패했습니다.');
        }
    };

    const handleEditStart = (item) => {
        setEditingId(item.idNo);
        setEditingEmail(item.email);
    };

    const handleEditCancel = () => {
        setEditingId(null);
        setEditingEmail('');
    };

    const handleEditSave = async (idNo) => {
        try {
            if (!editingEmail.trim()) {
                alert('이메일을 입력해주세요.');
                return;
            }

            await axios.post(`${API_URL}/monitoring-manage/updateAdminEmail`, {
                changingData: {
                    idNo,
                    email: editingEmail.trim()
                }
            });

            setEditingId(null);
            setEditingEmail('');
            getAdminEmails();
        } catch (err) {
            console.error(err);
            alert(err?.response?.data?.message || '이메일 수정에 실패했습니다.');
        }
    };

    const handleDelete = async (idNo) => {
        try {
            const ok = await confirm(
               '해당 이메일을 삭제하시겠습니까?','삭제', '취소'
            );

            if (!ok) return;

            await axios.post(`${API_URL}/monitoring-manage/deleteAdminEmail`, { idNo });
            getAdminEmails();
        } catch (err) {
            console.error(err);
            alert(err?.response?.data?.message || '이메일 삭제에 실패했습니다.');
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={customStyles}
            contentLabel={contentLabel}
        >
            <div className="modalContentArea adminEmails">
                <div className="modalHeader">
                    <h2 className="modalTitle">알람 수신 이메일</h2>
                    <button className="closeBtn" onClick={onRequestClose}>✕</button>
                </div>

                <div className="adminEmailsBody">
                    <div className="addArea">
                        <input
                            type="text"
                            placeholder="이메일 입력"
                            value={newEmail}
                            onChange={(e) => setNewEmail(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') handleAdd();
                            }}
                        />
                        <button onClick={handleAdd}>추가</button>
                    </div>

                    <div className="listArea">
                        {loading ? (
                            <div className="emptyMsg">불러오는 중...</div>
                        ) : emailList.length === 0 ? (
                            <div className="emptyMsg">등록된 이메일이 없습니다.</div>
                        ) : (
                            emailList.map((item) => (
                                <div className="emailRow" key={item.idNo}>
                                    {editingId === item.idNo ? (
                                        <>
                                            <input
                                                type="text"
                                                value={editingEmail}
                                                onChange={(e) => setEditingEmail(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') handleEditSave(item.idNo);
                                                }}
                                            />
                                            <div className="btnArea">
                                                <button
                                                    className="saveBtn"
                                                    onClick={() => handleEditSave(item.idNo)}
                                                >
                                                    저장
                                                </button>
                                                <button
                                                    className="cancelBtn"
                                                    onClick={handleEditCancel}
                                                >
                                                    취소
                                                </button>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="emailText">{item.email}</div>
                                            <div className="btnArea">
                                                <button
                                                    className="editBtn"
                                                    onClick={() => handleEditStart(item)}
                                                >
                                                    수정
                                                </button>
                                                <button
                                                    className="deleteBtn"
                                                    onClick={() => handleDelete(item.idNo)}
                                                >
                                                    삭제
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default AdminEmails;